import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import routes, { RouteInterface } from './routes';
import { useAppContext } from '@ids/context/App';

const Router = () => {
    const { idsPath } = useAppContext();

    return (
        <Switch>
            {routes.map((route: RouteInterface) => (
                <Route
                    key={`${idsPath}${route.path}`}
                    path={`${idsPath}${route.path}`}
                    exact={route.exact}
                    render={props => <route.component {...props} />}
                />
            ))}
        </Switch>
    );
};

export default Router;
